import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { AssetUrlService } from 'src/app/services/basic/asset-url.service';
import { InfozonemodalComponent } from 'src/app/components/infozonemodal/infozonemodal.component';
import { VideomodalComponent } from 'src/app/components/videomodal/videomodal.component';

@Component({
    selector: 'app-smblocklistitem',
    templateUrl: './smblocklistitem.component.html',
    styleUrls: ['./smblocklistitem.component.scss'],
    standalone: false
})
export class SmblocklistitemComponent implements OnInit {
  @Input() b: any;
  public basepath = '';

  private assetUrl = inject(AssetUrlService);

  constructor(
    public data: DataService,
    public router: Router,
    public route: ActivatedRoute,
    public http: HttpClient,
    public alertController: AlertController,
    public modalController: ModalController
  ) {
  }

  ionViewWillEnter() {
    console.log(' will this.data.basePath');
    console.log(this.data.basePath);
    this.basepath = this.assetUrl.getMediaBase();
  }

  ngOnInit() {
    console.log(' init this.data.basePath');
    console.log(this.b);
    console.log(this.data.basePath);
    this.basepath = this.assetUrl.getMediaBase();
  }

  async navigate() {
    let id = this.route.snapshot.paramMap.get("id");
    let module_id = this.route.snapshot.paramMap.get("module");
    this.data.visitbox(module_id, this.b.id);

    console.log('/smpage/' + this.b.nav_id + '/' + module_id)
    if (this.b.nav_id) {
      this.router.navigateByUrl('/smpage/' + this.b.nav_id + '/' + module_id);
      return;
    }

    if (this.b.video) {
      let that = this
      let video = this.b.video;
      const modal = await this.modalController.create({
        component: VideomodalComponent,
        animated: false,
        htmlAttributes: { 'aria-label': 'Video: ' + (video?.title || '') },
        componentProps: {
          video: video,
          basepath: that.assetUrl.getMediaBase()
        }
      });

      let payload = {
        token: this.data.token,
        title: 'Open video ' + video.title,
        pathway_id: that.data.pathway ? that.data.pathway.id : '',
        condition: (that.data.pathway && that.data.pathway.condition) ? that.data.pathway.condition.id : ''
      };
      void this.data.apiPost('userappnav', payload);
    return await modal.present();
    }

    if (this.b.infozone) {
      let infozone = this.b.infozone;
      let that = this
      const modal = await this.modalController.create({
        component: InfozonemodalComponent,
        animated: false,
        htmlAttributes: { 'aria-label': 'Info: ' + (infozone?.title || '') },
        componentProps: {
          infozone: infozone,
          basepath: that.assetUrl.getMediaBase()
        }
      });

      let payload = {
        token: this.data.token,
        title: 'Open infozone ' + infozone.id,
        pathway_id: that.data.pathway ? that.data.pathway.id : '',
        condition: (that.data.pathway && that.data.pathway.condition) ? that.data.pathway.condition.id : ''
      };
      void this.data.apiPost('userappnav', payload);
    return await modal.present();

    }


  }

  safeURL(item) {
    return encodeURI(item);
  }

  mediaUrl(path: string): string {
    return this.assetUrl.mediaUrl(path);
  }

  isboxVisited() {
    return this.data.isboxVisited(this.b.id, this.route.snapshot.paramMap.get("module"));
  }

}